import {
  USER,
  USER_CAPTCHA,
  USER_CREATE_PASSWORD,
  USER_FORGOT_PASSWORD,
  USER_LOGIN,
  USER_SIGNUP,
  USER_VERIFY_PASSWORD,
  DETAILS,
  BOOKING_LIST,
  CHECKOUT,
  CANCEL_TICKET,
  REFRESHTOKEN,
} from "./constants";
import { http } from "./httpServices";

export function userLogin(data) {
  return http.post(`${USER}${USER_LOGIN}`, data);
}

export function userForgotPassword(data) {
  return http.post(`${USER}${USER_FORGOT_PASSWORD}`, data);
}

export function userVerifyPassword(data) {
  return http.post(`${USER}${USER_VERIFY_PASSWORD}`, data);
}

export function userCreatePassword(data) {
  return http.post(`${USER}${USER_CREATE_PASSWORD}`, data);
}

export function userGetCaptcha() {
  return http.get(`${USER}${USER_CAPTCHA}`);
}
export function userSignup(data, param) {
  return http.post(`${USER}${USER_SIGNUP}`, data);
}
export function getUserData() {
  return http.get(`${USER}${DETAILS}`);
}
export function getPurchaseList(month, type, year, filter) {
  return http.get(`${USER}${BOOKING_LIST}`, {
    params: {
      month,
      type,
      year,
      filter,
    },
  });
}

export function cancelTicket(data) {
  return http.post(`${CHECKOUT}${CANCEL_TICKET}`, data);
}

export function refreshToken(data) {
  return http.post(`${REFRESHTOKEN}`, data);
}
